import { PropsWithChildren } from 'react';
import './basic_box.css';

interface BasicBoxProps {
    className?: string;
    flexDirection: 'row' | 'column';
}

const defaultProps = {
    flexDirection: 'column',
};

const BasicBox = (props: PropsWithChildren<BasicBoxProps>) => {
    const customClassName = props.className ? ` ${props.className}` : '';
    return (
        <>
            <div
                className={`basic_box_container ${props.flexDirection} ${customClassName}`}
            >
                {props.children}
            </div>
        </>
    );
};

BasicBox.defaultProps = defaultProps;

export default BasicBox;
